import { useState } from "react";
import { Row, Col, Input } from "reactstrap";
import DataTable from "react-data-table-component";
import { useMutation } from "@apollo/client";

import { simpleDate, simpleTime } from "../../../utils/displayDate";
import { customTableStyles } from "../styles/table";
import { numberWithCommas } from "../../../utils/math";
import {
  renderAction,
  renderStatus,
} from "../../../components/transaction/renderBadge";
import { ChevronIcon, TrashIcon } from "../../../constants/icon_path";
import LoadingTable from "../../../components/common/LoadingTable";
import { DELETE_TRANSACTION } from "../../../graphql/mutations/transaction";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../components/common/CustomErrorMessage";

const TransactionListTable = ({ data, loading, refetch }) => {
  const [searchValue, setSearchValue] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  const [deleteTransaction] = useMutation(DELETE_TRANSACTION, {
    onCompleted: (data) => {
      if (data.deleteTransaction) {
        showSuccessToast();
        refetch();
      }
    },
    onError(err) {
      showErrorToast(err.message);
    },
  });

  const handleDelete = (id) => {
    const answer = window.confirm("ຕ້ອງການລຶບຂໍ້ມູນບໍ?");
    if (answer) {
      deleteTransaction({ variables: { id } });
    }
  };

  const showData = searchValue.length ? filteredData : data;
  // ** Function to handle filter
  const handleFilter = (e) => {
    const value = e.target.value;
    let updatedData = [];
    setSearchValue(value);

    if (value.length) {
      updatedData = data?.filter((item) => {
        const startsWith =
          item.member.memberId.toString().startsWith(value.toString()) ||
          item.member.nickname
            .toLowerCase()
            .toString()
            .startsWith(value.toString());
        const includes =
          item.member.memberId.toString().includes(value.toString()) ||
          item.member.nickname
            .toLowerCase()
            .toString()
            .includes(value.toString());

        if (startsWith) {
          return startsWith;
        } else if (!startsWith && includes) {
          return includes;
        } else return null;
      });

      setFilteredData(updatedData);
      setSearchValue(value);
    }
  };

  const columns = [
    {
      name: "ວັນທີ່",
      selector: (row) => (
        <span className="d-flex flex-column">
          <span>{simpleDate(row.createdAt)}</span>
          <span>{simpleTime(row.createdAt)}</span>
        </span>
      ),
      center: true,
      sortable: true,
      className: "notolao",
    },
    {
      name: "ລະຫັດລູກຄ້າ",
      selector: (row) => row.member?.memberId,
      center: true,
      sortable: true,
      className: "notolao",
    },
    {
      name: "ຊື່ລູກຄ້າ",
      selector: (row) => row.member?.nickname,
      center: true,
      sortable: true,
    },
    {
      name: "ຈຳນວນເງິນ",
      selector: (row) => numberWithCommas(row.amount),
      center: true,
      sortable: true,
    },
    {
      name: "ທຸລະກຳ",
      selector: (row) => renderAction(row.action),
      sortable: true,
      center: true,
    },

    {
      name: "ສະຖານະ",
      selector: (row) => renderStatus(row.status),
      sortable: true,
      center: true,
    },
    {
      name: "ຈັດການ",
      center: true,
      cell: (row) => (
        <>
          <TrashIcon
            size={20}
            onClick={() => handleDelete(row.id)}
            color="red"
          />
        </>
      ),
    },
  ];

  return (
    <>
      <Row className="mb-2 d-flex">
        <Col md="6">
          <Input
            type="text"
            value={searchValue}
            onChange={handleFilter}
            placeholder="ຄົ້ນຫາ"
            size="sm"
          />
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <DataTable
            noHeader
            pagination
            data={showData}
            columns={columns}
            className="react-dataTable"
            sortIcon={<ChevronIcon size={10} />}
            filteredData="true"
            customStyles={customTableStyles}
            paginationRowsPerPageOptions={[50, 100, 150, 200]}
            progressComponent={<LoadingTable />}
            progressPending={loading}
            paginationPerPage={50}
          />
        </Col>
      </Row>
    </>
  );
};

export default TransactionListTable;
